const pageConfig = {
  current: 1,
  pageSize: '10',
  page_index: 1,
  page_size: '10',
};
const pagination = {
  hideOnSinglePage: false,
  showQuickJumper: true,
  showSizeChanger: true,
  pageSizeOptions: ['10', '20', '50', '100'],
};
const res = {
  data: [],
  total: 0,
};

const getColumnsWidth = columns => {
  let widthCount = 0;

  columns.map(item => {
    const { width = 160 } = item;

    widthCount += width;
  });
  return widthCount;
};

export { pageConfig, pagination, res, getColumnsWidth };
